var scope_0 = require('/home/runner/work/AluPriser.dk/AluPriser.dk/site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/256a96c5b2dce98a28ef889bfac2e2d2.js').default;
var scope_1 = require('/home/runner/work/AluPriser.dk/AluPriser.dk/site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/bb371b604cd58d6bdc41f05f30d23fb7.js').default;
var scope_2 = require('/home/runner/work/AluPriser.dk/AluPriser.dk/site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c53763a1f931db0fdef494c59869047c.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    